export enum AuthCallbackPath {
  FUNDING_APPLICATION = "funding-application:funding-application-connections", // Default
  FUNDING_APPLICATION_ADD_CONNECTION = "funding-application:funding-application-connections-add",
  FUNDING_APPLICATION_AIRS_REVIEW = "funding-application:funding-application-connections-airs-review",
  FUNDING_APPLICATION_BANKING = "funding-application:funding-application-connections-banking",
  ADDITIONAL_FUNDING_TASK_AIR_CONNECTION =
  "funding-application:additional-funding-application-customer-task-air-connection",
  CUSTOMER_TASK_AIR_CONNECTION = "funding-application:funding-application-customer-task-air-connection",
}
